<fa-icon icon="copy" (click)="copyText()" [matTooltip]="tooltipLabel"></fa-icon>
